// Help icon on form => open and close Learn More modal

const toggleLearnMore = function ($) {
	$(".plank-help").click(function () {
		$(".learn-more__modal").addClass("js-open-modal");

		// prevents body from scrolling when modal is open
		$("html").css("overflow", "hidden");
	});

	$(".learn-more__close").click(function () {
		$(".learn-more__modal").removeClass("js-open-modal");

		// allows body to return to regular scroll
		$("html").css({ "overflow-y": "scroll", "overflow-x": "hidden" });
	});
};

export default toggleLearnMore;
